// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"740adf77a463fc38","825":"1e5e1b8ddeab5977","931":"b5131152d92fbb21"}[chunkId] + ".css";
};